import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectIndicatorsFetchFailedAction = {
	type: 'SUBJECT_INDICATORS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectIndicatorsFetchFailedAction => ({
	type: 'SUBJECT_INDICATORS_FETCH_FAILED',
	payload,
});
